import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useRef } from "react";

function PendingAgendaConfirmDialog({ open, onClose, onConfirm, agendaId }) {
    const pendingTextRef = useRef(null);

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle>Askıya Alma İşlemi</DialogTitle>
            <DialogContent dividers>
                <Typography sx={{ mb: 2 }}>Askıya alma işlemini onaylıyor musunuz?</Typography>
                <TextField
                    key={agendaId}
                    fullWidth
                    label="Askıya alma gerekçeniz"
                    inputRef={pendingTextRef}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Vazgeç</Button>
                <Button
                    variant="contained"
                    onClick={() => onConfirm(pendingTextRef.current.value)}
                >
                    Evet
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PendingAgendaConfirmDialog;
